"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bootstrap = void 0;

var _initializeAxios = require("@insided/shared/bootstrap/initializeAxios");

var _initializeGlobals = require("./initializeGlobals");

var _polyfills = require("@insided/shared/polyfills");

var _bootstrap = require("@insided/shared/bootstrap");

var _initializeTracking = require("./initializeTracking");

var _initializeApp = require("./initializeApp");

var _detectLogout = _interopRequireDefault(require("@insided/deprecated-utils/detectLogout"));

var _chWebSdk = require("./ch-web-sdk");

var _logger = require("@insided/shared/services/logger");

var bootstrap = function bootstrap() {
  /**
   * TLDR: Catches uncaught throws — `throw new Error()`, null refs, syntax errors, etc.
   *
   * Global catchers pick up everything — including customer inline scripts.
   * `origin: 'unhandled'` tells BrowserLogger to report them without the
   * "Browser" prefix so they don't look like platform bugs in NewRelic.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
   */
  window.addEventListener('error', function (event) {
    _logger.logger.error(event.error, {
      app: 'destination',
      source: 'window.onerror',
      origin: 'unhandled'
    });
  });
  /**
   * TLDR: Catches unhandled Promise rejections — `Promise.reject()`, async throws without `.catch()`.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
   */

  window.addEventListener('unhandledrejection', function (event) {
    _logger.logger.error(event.reason, {
      app: 'destination',
      source: 'unhandledrejection',
      origin: 'unhandled'
    });
  }); // Initialize external SDK

  (0, _chWebSdk.initChWebSdk)(); // Initialize core services

  (0, _initializeAxios.initializeAxios)();
  (0, _detectLogout.default)();
  (0, _polyfills.initializePolyfills)();
  (0, _initializeGlobals.initializeGlobals)(); // Initialize features

  (0, _initializeTracking.initializeTracking)();
  (0, _bootstrap.initializeUrlNavigation)(); // Initialize app

  (0, _initializeApp.initializeApp)(); // Notify web components that insided is ready

  document.dispatchEvent(new CustomEvent('insidedReady'));
};

exports.bootstrap = bootstrap;